import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import axios from 'axios';
function updateHubspotContactProperties(_x) {
  return _updateHubspotContactProperties.apply(this, arguments);
}
function _updateHubspotContactProperties() {
  _updateHubspotContactProperties = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var properties, _error$response, _t;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          properties = _ref.properties;
          _context.prev = 1;
          _context.next = 2;
          return axios.post('/api/me/hubspot/properties', {
            properties: properties
          });
        case 2:
          _context.next = 4;
          break;
        case 3:
          _context.prev = 3;
          _t = _context["catch"](1);
          _t.formattedErrorMessage = ((_error$response = _t.response) === null || _error$response === void 0 || (_error$response = _error$response.data) === null || _error$response === void 0 ? void 0 : _error$response.error) || _t.message;
          throw _t;
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 3]]);
  }));
  return _updateHubspotContactProperties.apply(this, arguments);
}
export default updateHubspotContactProperties;